module.exports = __webpack_public_path__ + "static/media/contact.d30c048d.png";